import React from 'react';
import LoungeHeading from "../../../components/LoungeHeading";
import { Link, useParams, NavLink } from "react-router-dom";
import useFetchPages from "../../../hooks/useFetchPages";
import { useRecoilValue } from "recoil";
import { spaceIdState } from "../../../state/spaceState";
import useFetchUser from "../../../hooks/useFetchUser";
import useTiming from "../../../hooks/useTiming";
import useUser from "../../../hooks/useUser";
import { useTranslation } from 'react-i18next';
import config from "../../../constants/config"
import { useFormatDate } from "../../../hooks/dates";
import useFetchTheatron from "../../../hooks/useFetchTheatron";
import boothModeState from "../../../state/ui/boothModeState";
import Footer from '../../../components/Footer';
import Loading from "../../Loading";
import useFetchStats from "../../../hooks/useFetchStats";

const BoothNavigation = () => {

    const user = useUser();
    const {data: stats} = useFetchStats();
    const timing = useTiming();
    const { formatTime, format } = useFormatDate()
    const { t } = useTranslation(['lounge', 'booth'])
    const startsAt = formatTime(timing.starts_at);
    const startsAtDateTime = format(timing.starts_at);
    const theatron = useFetchTheatron();

    const boothMode = useRecoilValue(boothModeState);
    const boothSectionTitleClassName = "mb-2 text-xs text-opacity-70 uppercase tracking-wide font-semibold text-white"

    if (!user) {
        return <Loading />;
    }

    return (
        <div className="flex flex-col px-6 py-10 h-full">
            <div>
                <p className={boothSectionTitleClassName}>{t('booth:control-booth')}</p>

                <LoungeHeading title={timing.event.title}>
                    <p className="text-gray-400 mb-8 text-left text-base lg:text-base md:text-sm dont-break-out">
                        {boothMode ? startsAtDateTime :
                            `${t('lounge:welcome-user', { user: user?.name || '', app: theatron.data?.name, event: timing.event.title }) +
                            ' ' + (timing.venue.type == 'vod' ? '' : t('lounge:show-starts-at', { starts: startsAt }))}`
                        }
                    </p>
                </LoungeHeading>

                <div className="text-white">
                    <hr className="mb-8 border-t border-white border-opacity-20 w-full" />
                    <p className={boothSectionTitleClassName}>{t('booth:menu')}</p>
                    <div className="w-full flex flex-col space-y-2 capitalize">
                        <NavLink to={`/${timing.id}`} exact activeClassName='opacity-100' className="rounded-lg py-1 opacity-60 w-full flex items-center space-x-3">
                            <i className="fas fa-home fa-fw"></i>
                            <span className="font-bold">{t('booth:home')}</span>
                        </NavLink>
                        <NavLink to={`/${timing.id}/polls`} exact activeClassName='opacity-100' className="rounded-lg py-1 opacity-60 w-full flex items-center space-x-3">
                            <i className="fas fa-poll fa-fw"></i>
                            <span className="font-bold">{t('booth:polls')}</span>
                        </NavLink>
                    </div>
                </div>
            </div>

            <Footer>
                <div className="bg-green-900 rounded-xl p-3 px-4 flex flex-col space-y-2 text-white">
                    <p className="uppercase tracking-wide font-bold opacity-70 text-xs">Checked-in</p>
                    <div className="flex flex-row items-end font-bold">
                        <span className="text-green-400 text-2xl leading-tight">{stats?.attendees?.toFixed(0) || <>&mdash;</>}</span>
                        <span className="">&nbsp;/ {stats?.tickets?.toFixed(0) || <>&mdash;</>} attendees</span>
                    </div>
                </div>
            </Footer>
        </div>
    )
}

export default BoothNavigation
